import { Component, input } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { IEmployeeSimple } from 'src/app/shared/models';

@Component({
  selector: 'app-autocomplete-person',
  templateUrl: './autocomplete-person.component.html',
  styleUrls: ['./autocomplete-person.component.scss'],
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
  ],
})
export class AutocompletePersonComponent {
  readonly required = input(false);
  readonly label = input<string>(undefined);
  readonly controller = input<FormControl<IEmployeeSimple | null>>(undefined);
  readonly options = input<IEmployeeSimple[]>([]);

  filteredOptions: IEmployeeSimple[] = [];

  filter(value: string) {
    this.filteredOptions = this.options().filter((option) =>
      option.fullName.toLowerCase().includes(value.toLowerCase()),
    );
  }

  empty(value: string) {
    if (value.trim()) return;

    this.controller().setValue(null);
  }

  displayFn(user: IEmployeeSimple) {
    return user?.fullName;
  }
}
